import { render, staticRenderFns } from "./formTaskAllocation.vue?vue&type=template&id=c7cec880&scoped=true"
import script from "./formTaskAllocation.vue?vue&type=script&lang=js"
export * from "./formTaskAllocation.vue?vue&type=script&lang=js"
import style0 from "./formTaskAllocation.vue?vue&type=style&index=0&id=c7cec880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cec880",
  null
  
)

export default component.exports